// Pre-selection of context cases (backend v2.4).
//
// /API_get_uploaded_case_data returns, next to the uploaded case's position on the map, the 10
// decisions most similar to it by cosine similarity of the retrieval vectors (`similar_cases`, in
// the same format as the map data, most similar first). The map shows where a case falls, but the
// points nearest to it on the map are only partly the most similar decisions, so the selection
// offered to the user comes from the vectors; the user confirms or changes it on the map.

export const MAX_SELECTED_ACCORDS = 10;

// Convert `similar_cases` of the uploaded case data into accord objects (as Home builds them from
// the map data), most similar first. Returns [] when there is no pre-selection.
export const similarCasesToAccords = (uploaded) => {
  const similar = uploaded?.similar_cases;
  if (!similar || !Array.isArray(similar.filtered_data_ids) || !similar.embeddings_2D || !similar.hover_data) {
    return [];
  }
  const hover = similar.hover_data;
  return similar.filtered_data_ids.slice(0, MAX_SELECTED_ACCORDS).map((id, index) => ({
    id,
    x: similar.embeddings_2D.x?.[index],
    y: similar.embeddings_2D.y?.[index],
    result: hover.acordao_resultado?.[index],
    ementa: hover.acordao_ementa?.[index],
    penalidade: hover.acordao_penalidade?.[index],
    baseLegal: hover.acordao_base?.[index],
    ano: hover.ano_sessoes?.[index],
    sessao: hover.sessao_nr_int?.[index],
    processo: hover.acordao_titulo?.[index],
    similarity: similar.similarity?.[index],
    preselected: true,
  }));
};
